import { TypeDefinition } from "../generic";

export class GradingStatuses {
    public static Ungraded: TypeDefinition = { id: 0, name: "Ungraded" };
    public static Graded: TypeDefinition = { id: 1, name: "Graded" };

    public static Values: TypeDefinition[] = [
        GradingStatuses.Ungraded,
        GradingStatuses.Graded,
    ];

    public static isGraded = (statusId: number | { gradingStatusId: number }) => {
        const s = typeof statusId === "number" ? statusId : statusId.gradingStatusId;
        return s === GradingStatuses.Graded.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/abstract/GradingStatuses.ts